import React from 'react';
import c from 'classnames';

import ButtonWrapper, { type ButtonWrapperProps } from '../ButtonWrapper';
import './style.scss';

const ActionButton: React.FC<ButtonWrapperProps> = ({ className, ...props }) => (
  <ButtonWrapper className={c('ActionButton', className)} {...props} />
);

export default ActionButton;
